import { HugeiconsIcon } from '@hugeicons/react';
import { KanbanIcon, LeftToRightListDashIcon } from '@hugeicons/core-free-icons';
import { MultiSelectFilter } from '../../shared/MultiSelectFilter';
import { ISSUE_STATUS_OPTIONS } from '../../../lib/issueTypeOptions';
import { BOARD_STATUSES, type IssueBoardPreferences } from './useIssueBoardPreferences';

export function IssueBoardControls({ preferences }: { preferences: IssueBoardPreferences }) {
  if (preferences.view !== 'board') return null;
  return <div className="flex justify-end mb-3">
    <div data-columns-picker>
      <MultiSelectFilter icon={KanbanIcon} name="Columns" idleLabel="Columns" aria-label="Visible columns" className="input-sm"
        options={ISSUE_STATUS_OPTIONS} value={preferences.visible} defaultValue={BOARD_STATUSES}
        resetLabel="Show all columns" onChange={preferences.setVisible} />
    </div>
  </div>;
}

export function IssueViewToggle({ preferences }: { preferences: IssueBoardPreferences }) {
  return <div role="group" aria-label="Issue view" className="inline-flex h-[var(--oq-control-app-toolbar-height)] shrink-0 items-stretch rounded-md border border-gray-200 overflow-hidden divide-x divide-gray-200">
    {([{ value: 'table', label: 'Table view', icon: LeftToRightListDashIcon }, { value: 'board', label: 'Board view', icon: KanbanIcon }] as const).map(option =>
      <button key={option.value} type="button" aria-label={option.label} title={option.label} aria-pressed={preferences.view === option.value}
        onClick={() => preferences.setView(option.value)}
        className={`flex items-center justify-center w-[var(--oq-control-app-toolbar-height)] h-full transition-colors outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-primary-300 ${preferences.view === option.value ? 'bg-primary-50 text-primary-600' : 'bg-white text-gray-500 hover:text-gray-700 hover:bg-gray-50'}`}>
        <HugeiconsIcon icon={option.icon} size={16} strokeWidth={2} color="currentColor" aria-hidden="true" />
      </button>)}
  </div>;
}
